import styled from '@emotion/styled'
import { colors, font, spacing } from '@mobi/component-library/Foundations'

const themes = {
  neutral: {
    '--background-color': colors.greyDark,
    '--color': colors.white,
  },
  primary: {
    '--background-color': colors.mariner[500],
    '--color': colors.white,
  },
  success: {
    '--background-color': colors.sushi[500],
    '--color': colors.white,
  },
  warning: {
    '--background-color': colors.warning[500],
    '--color': colors.black,
  },
  error: {
    '--background-color': colors.error[600],
    '--color': colors.white,
  },
} as const

export type ThemeName = keyof typeof themes

type Props = {
  type: ThemeName
}

export const BannerStyled = styled.div<Props>(
  {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.md,
    backgroundColor: 'var(--background-color)',
    boxSizing: 'border-box',
    color: 'var(--color)',
    fontSize: font.size.md.fontSize,
    lineHeight: font.size.md.lineHeight,
    fontWeight: font.weight.regular,
    padding: `${spacing.sm} ${spacing.md}`,

    '> svg': {
      flex: '0 0 auto',
      fill: 'none', // Required because Mobi sets `fill: currentColor`
    },

    '> p': {
      flex: '1 1 auto',
      fontSize: 'inherit',
      margin: 0,
      textAlign: 'left',
    },

    '> button, > a': {
      flexShrink: 0,
    },

    'button[name="close_button"]': {
      color: colors.white,

      ':hover': {
        color: colors.neutral[900],
      },
    },
  },
  ({ type }: Props) => themes[type]
)
